import { SyntheticEvent } from 'react';

import { ItemLabelModel } from '../../../../../shared/components/dropdown/models/dropdown-props.model';
import { SetFieldValueType } from '../../../../types/set-field-value.type';
import { FirmwareDetailsFormModel } from '../../models/firmware-form.model';
import { FieldsToResetConfigModel } from './models/fields-to-reset-config.model';

export const useOnFirmwareDetailsDependentSelectChange = (
  setFieldValue: SetFieldValueType,
  selectedInput: keyof FirmwareDetailsFormModel,
  fieldsToReset: FieldsToResetConfigModel[],
  setFieldTouched: (
    field: string,
    isTouched?: boolean | undefined,
    shouldValidate?: boolean | undefined
  ) => void
): ((
  event: SyntheticEvent,
  selectedInputValue:
    | string
    | ItemLabelModel<number>
    | (string | ItemLabelModel<number>)[]
    | null
) => void) => {
  return function (
    event: SyntheticEvent,
    selectedInputValue:
      | string
      | ItemLabelModel<number>
      | (string | ItemLabelModel<number>)[]
      | null
  ): void {
    setFieldTouched(selectedInput as string, true, false);
    fieldsToReset.forEach(item => {
      setFieldValue(item.field, item.valueToReset, false);
      setFieldTouched(item.field, true, false);
    });
    setFieldValue(selectedInput as string, selectedInputValue, true);
  };
};
